import ReactGA from 'react-ga';
import { GaDispatcher, getGaTrackedActivityConverterForSitecore } from "@uniformdev/tracking";
export function getDispatchersForGaDestinations(destinations, logger) {
  var dispatchers = [];
  destinations.forEach(function (destination) {
    var dispatcher = getDispatcherForGa(destination, logger);
    if (!dispatcher) {
      logger.error("useSitecoreTracker - Unable to get dispatcher for GA destination.", destination);
      return;
    }
    dispatchers.push(dispatcher);
  });
  return dispatchers;
}
function getDispatcherForGa(destination, logger) {
  if (!destination) {
    return;
  }
  if (!initializeGa(destination, logger)) {
    logger.debug("useSitecoreTracker - Unable to initialize GA so no GA dispatch will be performed.", destination);
    return;
  }
  var converters = getActivityConvertersForGa(destination, logger);
  var dispatcher = new GaDispatcher(converters, destination);
  if (destination.mappings) {
    var mappings = destination.mappings;
    var setValues = function setValues(_results, values) {
      mappings.forEach(function (mapping) {
        if (!mapping.action) {
          return;
        }
        var action = new Function(mapping.action);
        var result = action();
        if (result) {
          values.set(mapping.index, result);
        }
      });
    };
    dispatcher.setCustomDimensionValues = setValues;
  }
  return dispatcher;
}
/**
 * Returns true if all tracking ids could be initialized.
 * @param destination
 * @param logger
 */
function initializeGa(destination, logger) {
  if (!destination.trackingIds || destination.trackingIds.length == 0) {
    logger.debug("useSitecoreTracker - GA destination has no tracking ids assigned, so no GA initialization will be performed.", destination);
    return false;
  }
  var didInitialize = true;
  destination.trackingIds.forEach(function (id) {
    logger.debug("useSitecoreTracker - Will initialize GA from tracking id " + id);
    try {
      ReactGA.initialize(id, {
        gaOptions: {
          name: id
        }
      });
    } catch (ex) {
      logger.error("useSitecoreTracker - Error while initializing GA from tracking id " + id, ex);
      didInitialize = false;
    }
  });
  return didInitialize;
}
/**
 * Gets the tracked activity converters for the specified destination.
 * @param destination
 * @param logger
 */
function getActivityConvertersForGa(destination, logger) {
  var _a;
  var converters = (_a = destination.activityConverters) !== null && _a !== void 0 ? _a : [];
  if (destination.doNotUseDefaultActivityConverter != true) {
    var converter = getGaTrackedActivityConverterForSitecore();
    if (converter) {
      if (converters.every(function (c) {
        return c.type != converter.type;
      })) {
        converters.push(converter);
        logger.debug("useSitecoreTracker - Added default GA tracked activity converter for Sitecore.", {
          converters: converters
        });
      }
    }
  }
  return converters;
}